/**
 * Türkçe duyarlı basit arama yardımcıları (istemci tarafı listeler için).
 *
 * `"İ".toLowerCase()` JavaScript'te i + birleşen nokta (iki karakter) üretir,
 * bu yüzden düz küçük harfe çevirme "İPLİK" ile "iplik"i eşleştiremez.
 * Aramada Türkçe harfler ASCII karşılığına indirgenir — "sekar" yazınca
 * "Şeker" de bulunur.
 */
export const trNorm = (s) => (s || '')
  .replace(/[İIı]/g, 'i').replace(/[çÇ]/g, 'c').replace(/[ğĞ]/g, 'g')
  .replace(/[öÖ]/g, 'o').replace(/[şŞ]/g, 's').replace(/[üÜ]/g, 'u')
  .toLowerCase();

/**
 * Sorgudaki her kelime hedefte geçiyor mu? "dana kiy" → "Dana Kıyma" bulur.
 */
export const kelimeleriIceriyor = (sorgu, hedef) => {
  const q = trNorm(sorgu).trim();
  if (!q) return true;
  const h = trNorm(hedef);
  return q.split(/\s+/).every(parca => h.includes(parca));
};
